<div class="spinner">
  <ngx-spinner name="loading"></ngx-spinner>
</div>
